export default __webpack_public_path__ + "static/media/card2-4.3c8016f0.jpg";